<div class="flex-row column">
  <div class="flex-row align-center content-between mb-25">
    <p class="color-primary fw-7">Make Payment Via UPI ID</p>
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close()">
      <img class="cursor-pointer" src="assets/new-assets/icons/icon-close-dialog.svg" alt="Close">
    </button>
  </div>
  <div class="flex-row column">
    <p class="color-secondary mb-5">UPI ID</p>
    <mat-form-field appearance="outline" style="width: 80%;">
      <input matInput type="text" placeholder="upi@upi" [formControl]="vpaID" aria-label="Enter your UPI id">
    </mat-form-field>
    <span class="text-danger" *ngIf="vpaID.touched && vpaID.invalid">Please provide a valid UPI ID.</span>
    <div class="flex-row content-end mt-20">
      <button type="button" class="btn btn-primary" [disabled]="vpaID.invalid" (click)="confirm()">Confirm</button>
    </div>
  </div>
</div>